import { render } from "./ClientContract.vue?vue&type=template&id=2b82499a&scoped=true"
import script from "./ClientContract.vue?vue&type=script&lang=js"
export * from "./ClientContract.vue?vue&type=script&lang=js"

import "./ClientContract.vue?vue&type=style&index=0&id=2b82499a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b82499a"]])

export default __exports__